import { render, staticRenderFns } from "./index.vue?vue&type=template&id=638b8f45&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=638b8f45&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b8f45",
  null
  
)

export default component.exports